import { render, staticRenderFns } from "./FeedTankStrainChart.vue?vue&type=template&id=fd38d1b2&"
import script from "./FeedTankStrainChart.vue?vue&type=script&lang=ts&"
export * from "./FeedTankStrainChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports